import { render, staticRenderFns } from "./promisePrescriptModal.vue?vue&type=template&id=7b0ffb4e"
import script from "./promisePrescriptModal.vue?vue&type=script&lang=js"
export * from "./promisePrescriptModal.vue?vue&type=script&lang=js"
import style0 from "./promisePrescriptModal.vue?vue&type=style&index=0&id=7b0ffb4e&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports